import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getStationImages } from '../../../api/stations';

const useGetStationImages = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) =>
  useQuery({
    queryKey: ['stationImages'],
    queryFn: getStationImages,
    ...options,
  });

export default useGetStationImages;
